export default "__VITE_ASSET__BVB3iHRd__"